/**
 * 获取当前时间戳（秒）
 */
function getTimestamp() {
    return new Date().getTime() / 1000;
}
export { getTimestamp };
